// src/components/ErrorBoundary.jsx
import React from 'react';
import { warning } from "@alert";

// 實現錯誤邊界需要使用 componentDidCatch 和 getDerivedStateFromError 
// 這兩個生命週期方法，而這些方法目前在函數元件和 Hooks 中沒有等效的 API
// 雖然大部分 React 功能都已經可以通過 Hooks 實現，但錯誤邊界是個例外

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      isChunkError: false, // 標記是否為程式分割錯誤
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(err) {
    // 檢查是否是程式碼分割的錯誤
    const isChunkError = 
      err.name === 'ChunkLoadError' || 
      (err.message && err.message.includes('Loading chunk') && err.message.includes('failed'));
    
    // 更新狀態，這樣下一次渲染會顯示錯誤介面
    return { 
      hasError: true, 
      isChunkError 
    };
  }

  componentDidCatch(errorObj, errorInfo) {
    // 您可以在這裡記錄錯誤資訊
    console.log("網站應用程式錯誤:", errorObj, errorInfo);
    
    // 檢查是否是程式分割錯誤
    const isChunkError = 
      errorObj.name === 'ChunkLoadError' || 
      (errorObj.message && errorObj.message.includes('Loading chunk') && errorObj.message.includes('failed'));
    
    this.setState({ isChunkError });
    
    if (isChunkError) {
      console.log("網路連接問題:", errorObj, errorInfo);
      warning(2, "網路連接問題", "載入應用程式資源失敗，可能是因為您的網路連接不穩定或我們正在更新服務。", "重新整理頁面", "取消", () => window.location.reload(), () => window.location.href = "/");
      // warning(2, //   "網路連接問題", //   "載入應用程式資源失敗，可能是因為您的網路連接不穩定或已斷開。", //   "重新整理頁面", "取消", //   () => window.location.reload(), //   () => window.location.href = "/"
      //);
    } else {
      console.log("一般錯誤:", errorObj, errorInfo);
      // 一般錯誤處理
      warning(1, "正在更新或未知錯誤", "網站正在更新或遇到未知錯誤，請嘗試重新整理。", "我了解了", null, () => window.location.reload());
    }
    
    // 可選：將錯誤資訊發送到後端或監控服務
    // sendErrorToServer(errorObj, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // 根據錯誤類型顯示不同的錯誤介面
      return (
        <div className="error-container" style={{ marginTop: '100px', padding: '20px', textAlign: 'center' }}>
          <h2>{this.state.isChunkError ? "網路連接問題" : "網站正在更新或遇到未知錯誤"}</h2>
          
          {this.state.isChunkError ? (
            <>
              <div>無法載入網站應用程式資源，這通常是因為網路連線問題導致的。<br/>
              請檢查您的網路連線是否正常，然後重新嘗試。</div>
            </>
          ) : (
            <div>很抱歉，網站正在更新或頁面載入遇到未知錯誤，請嘗試重新整理。</div>
          )}
          
          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={() => window.location.reload()} 
              style={{ 
                padding: '8px 16px', 
                backgroundColor: '#2E77D0', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px', 
                cursor: 'pointer',
                marginRight: '10px'
              }}
            >
              重新整理
            </button>
            
            {this.state.isChunkError && (
              <button 
                onClick={() => window.location.href = "/"} 
                style={{ 
                  padding: '8px 16px', 
                  backgroundColor: '#f5f5f5', 
                  color: '#333', 
                  border: '1px solid #ccc', 
                  borderRadius: '4px', 
                  cursor: 'pointer' 
                }}
              >
                返回首頁
              </button>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;